import { useEffect } from "react"
import { Auth0Provider } from "@equipmentshare/auth0-react"
import { LicenseInfo } from "@mui/x-license"

import { AxiosInterceptorsProvider } from "./AxiosInterceptorsProvider"
import { ReactQueryProvider } from "./ReactQueryProvider"
import { GlobalToastProvider } from "./GlobalToastProvider"
import { ThemeProvider } from "./ThemeProvider"
import { FeatureFlagProvider } from "./FeatureFlagProvider"
import CssBaseline from "@mui/material/CssBaseline"

import { AUTH0_DOMAIN, AUTH0_CLIENTID, AUTH0_AUDIENCE, MUI_LICENSE_KEY } from "@app/services/env"

export type AllProvidersProps = {
	children: React.ReactNode
}

export const AllProviders: React.FC<AllProvidersProps> = ({ children }) => {
	useEffect(() => {
		LicenseInfo.setLicenseKey(MUI_LICENSE_KEY)
	}, [])

	return (
		<Auth0Provider
			domain={AUTH0_DOMAIN}
			clientId={AUTH0_CLIENTID}
			audience={AUTH0_AUDIENCE}
			redirectUri={window.location.origin}
		>
			<FeatureFlagProvider>
				<AxiosInterceptorsProvider>
					<ReactQueryProvider>
						<ThemeProvider>
							<CssBaseline />
							<GlobalToastProvider>{children}</GlobalToastProvider>
						</ThemeProvider>
					</ReactQueryProvider>
				</AxiosInterceptorsProvider>
			</FeatureFlagProvider>
		</Auth0Provider>
	)
}
